import { BaseBetslipGroupPick } from '../../../../../core/picks/betslip-group-pick';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { BetslipV2Pick } from '../../../../../core/picks/betslip-v2-pick';
import { PickStatusChanged } from '../../../errors/result/pick-status-changed';
import { PickUpdaterBase } from './pick-updater';

/**
 * PickStatus pick updater.
 * After the betplacement we may receive PickStatusChanged error.
 * When we update the result status of the pick to the status of error.
 */
export default class BetslipErrorChangedOptionStatusUpdater extends PickUpdaterBase<PickStatusChanged> {
    protected updateV1Pick(pick: BetslipV1Pick, error: PickStatusChanged): void {
        pick.resultStatus = error.status;
    }

    protected updateV2Pick(pick: BetslipV2Pick, error: PickStatusChanged): void {
        pick.resultStatus = error.status;
    }

    protected updateGroupPick(pick: BaseBetslipGroupPick, error: PickStatusChanged): void {
        pick.resultStatus = error.status;
    }
}
